import gsap from 'gsap'
import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { reduceLogo } from './animations'

gsap.registerPlugin(ScrollTrigger)

export let lenis, scrollToStart

export const initLenis = () => {

	lenis = new Lenis({
		smoothWheel: true,
		smoothTouch: true,
		duration: 1.3,
		lerp: 0.1,
		wheelMultiplier: 0.6,
		touchMultiplier: 1.7,
		touchInertiaMultiplier: 12
	})

	function raf(time) {
		lenis.raf(time)
		if (lenis.scroll > 50) {
			document.documentElement.classList.add('lenis-scrolled')
		} else {
			document.documentElement.classList.remove('lenis-scrolled')
		}
		requestAnimationFrame(raf)
	}

	scrollTo()
	requestAnimationFrame(raf)

	lenis.on('scroll', (e) => {
		ScrollTrigger.update()
	})

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)

}

export const scrollTo = () => {
	const links = document.querySelectorAll('[data-scroll-to]')

	if (!links) return

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			const target = link.getAttribute('data-scroll-to')
			const offset = link.getAttribute('data-scroll-offset')
			const targetEl = document.querySelector(target)
			lenis.scrollTo(targetEl, {
				duration: 1.5,
				offset: offset,
				easing: (x) => {
					return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
				}
			})
		})
	})
}

scrollToStart = () => {
  lenis.scrollTo(0, { immediate: true })
}

export default () => {}
